var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentBank = function SvgContentBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1b1b1b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.063 11.813H3.938a.656.656 0 0 0-.657.656v3.937c0 .363.294.657.656.657h13.126a.656.656 0 0 0 .656-.657V12.47a.656.656 0 0 0-.657-.656M17.063 3.938H3.938a.656.656 0 0 0-.657.656V8.53c0 .363.294.656.656.656h13.126a.656.656 0 0 0 .656-.656V4.594a.656.656 0 0 0-.657-.657"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b1b",
    d: "M14.766 7.547a.984.984 0 1 0 0-1.969.984.984 0 0 0 0 1.969M14.766 15.422a.984.984 0 1 0 0-1.969.984.984 0 0 0 0 1.969"
  })));
};
export default SvgContentBank;